"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchScratchersUnclaimedPrizes = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/games/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var action_type_util_1 = require("../../action-type.util");
var fetchScratchersUnclaimedPrizes = function (page) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sort, publishedGames, _a, games, _i, _b, game, gamePrizes, e_1, e_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 11, , 12]);
                dispatch({ type: (0, action_type_util_1.REQUEST)(types_1.GET_SCRATCHERS_UNCLAIMED_PRIZES) });
                sort = 'sort=gameId,desc&sort=playBegin,desc';
                if (!page) return [3, 2];
                return [4, services_1.GamesService.getPublishedGames(page.number + 1, 10, '', sort, '1', false)];
            case 1:
                _a = _c.sent();
                return [3, 4];
            case 2: return [4, services_1.GamesService.getPublishedGames(0, 10, '', sort, '1', false)];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                publishedGames = _a;
                games = [];
                _i = 0, _b = publishedGames.parsedGames;
                _c.label = 5;
            case 5:
                if (!(_i < _b.length)) return [3, 10];
                game = _b[_i];
                gamePrizes = [];
                _c.label = 6;
            case 6:
                _c.trys.push([6, 8, , 9]);
                return [4, services_1.GamesService.getPrizesForGame(game.id)];
            case 7:
                gamePrizes = (_c.sent());
                if (gamePrizes.length > 0) {
                    games.push(__assign(__assign({}, game), { unclaimedPrizes: gamePrizes }));
                }
                return [3, 9];
            case 8:
                e_1 = _c.sent();
                return [3, 9];
            case 9:
                _i++;
                return [3, 5];
            case 10:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_1.GET_SCRATCHERS_UNCLAIMED_PRIZES),
                    payload: { games: games, page: publishedGames.page }
                });
                return [3, 12];
            case 11:
                e_2 = _c.sent();
                dispatch({ type: (0, action_type_util_1.FAILURE)(types_1.GET_SCRATCHERS_UNCLAIMED_PRIZES), payload: { error: e_2 } });
                return [3, 12];
            case 12: return [2];
        }
    });
}); }; };
exports.fetchScratchersUnclaimedPrizes = fetchScratchersUnclaimedPrizes;
//# sourceMappingURL=actions.js.map